import styled from 'styled-components';
import { PrimaryButton } from './buttons';

export const TableHeading = styled.div`
  display: flex;
  width: 100%;
  align-items: flex-end;
  border-bottom: 3px solid #d6001c;
  font-family: 'Roboto Condensed', sans-serif;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  margin-right: ${props => `${parseInt(props.scrollbarWidth) + 20}px`};
  @media(max-width: 900px){
    font-size: 10px;
    margin-right: ${props => `${parseInt(props.scrollbarWidth)}px`};
  }
`;

export const Th = styled.div`
  padding: 10px 10px 5px 5px;
  width: ${props => props.width};
`

export const Td = styled.div`
  padding: 0px 10px 0px 5px;
  width: ${props => props.width};
  font-size: ${props => props.fontSize ? props.fontSize : '14px'};
  line-height: 16px;
  position: relative;
  @media(max-width: 900px){
    font-size: 12px;
  }
`

export const TableContainer = styled.div`
  max-height: 1500px;
  width: 100%;
  overflow-x: hidden;
  overflow-y: scroll;
  display: flex;
  flex-wrap: wrap;
  margin-right: 20px;
  @media(max-width: 900px){
    margin-right: 0px;
  }
`;

export const RowsContainer = styled.div`
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  background-color: ${props => props.altRow && '#1e1f21'};
  &:hover {
    background-color: #262729;
  }
`;

export const ExtendedRow = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  height: 30px;
  @media(max-width: 768px){
    padding-bottom: 20px;
  }
`;

export const PlayerRow = styled.div`
  display: flex;
  width: 100%;
  height: 50px;
  align-items: center;
`;

export const Tr = styled.div`
  display: flex;
  padding: 0 20px 0 0;
  width: ${props => props.width};
`;

export const ActionButton = styled(PrimaryButton)`
  font-size: 14px;
  min-width: 40px;
`

export const ArrowIcon = styled.img.attrs(props => ({
  src: props.src
}))`
  cursor: pointer;
`;
